import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';
import { headerSettingsShape } from './headerWidgetHelper';
import { changeLanguage } from '../../actions/languageActions';

export function Header(props) {
  const {
    isMobile,
    language,
    changeLanguageAction = () => {},
    onChangeLanguage = () => {},
    ...settings
  } = props;

  const onChangeLanguageHandler = (language) => {
    changeLanguageAction(language);
    onChangeLanguage(language);
  };

  const HeaderComponent = isMobile ? MobileHeader : DesktopHeader;
  return (
    <HeaderComponent
      {...settings}
      isMobile={isMobile}
      language={language}
      onChangeLanguage={onChangeLanguageHandler}
    />
  );
}

Header.propTypes = {
  isMobile: PropTypes.bool,
  language: PropTypes.string,
  changeLanguageAction: PropTypes.func,
  onChangeLanguage: PropTypes.func,
  ...headerSettingsShape,
};

function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default connect(mapStateToProps, { changeLanguageAction: changeLanguage })(
  React.memo(Header)
);